
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M9.999 5c2.896-.044 5.8 1.956 7.586 3.92l.002.002a1.609 1.609 0 010 2.154l-.002.001C15.84 13 12.943 15.045 10 15c-2.944.046-5.84-2-7.584-3.922l-.002-.001a1.609 1.609 0 010-2.154l.002-.001C4.2 6.956 7.103 4.956 9.999 5zM3.156 9.593a.609.609 0 000 .814C4.828 12.248 7.471 14.043 9.991 14h.016c2.52.043 5.164-1.752 6.837-3.594a.609.609 0 000-.813c-1.71-1.88-4.361-3.633-6.837-3.591h-.016C7.515 5.96 4.864 7.713 3.156 9.593z","fill":"#5C6970"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.764 8.148a2 2 0 101.234 1.848 2.001 2.001 0 00-1.234-1.848zm-.766-1.152a3 3 0 013 3m-3-3a3 3 0 103 3","fill":"#5C6970"}})])
          )
        }
      }
    